import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAdmin, isAffiliate } from '../lib/authorization';

export default function PostLoginPage(): JSX.Element {
   if (isAdmin()) {
      return <Navigate to="/firm-info" replace />;
   } else if (isAffiliate()) {
      return <Navigate to="/affiliate" replace />;
   } else {
      return <Navigate to="/" replace />;
   }
}
